"use client";
import { ConfigProvider } from "antd";
import React, { useState, useLayoutEffect } from "react";
import { colors } from "gstyles";
import { StyleProvider } from "@ant-design/cssinjs";

const App: React.FC = ({ children }: any) => {
  const [cache, setCache] = useState<any>();
  const [stylesLoaded, setStylesLoaded] = useState(false);

  useLayoutEffect(() => {
    // Tạo CSS cache để tránh FOUC
    import("@ant-design/cssinjs").then(({ createCache }) => {
      const newCache = createCache();
      setCache(newCache);

      // Thêm class khi styles đã load
      setTimeout(() => {
        document.body.classList.add("antd-styles-loaded");
        setStylesLoaded(true);
      }, 100);
    });
  }, []);

  if (!cache) {
    // Loading skeleton hoặc placeholder để tránh flash
    return (
      <div className="min-h-screen bg-white fixed inset-0 z-50">
        <div className="absolute inset-0 bg-white/90 z-50 flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
        <div className="opacity-70 pointer-events-none">{children}</div>
      </div>
    );
  }

  return (
    <StyleProvider cache={cache}>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: colors.primary,
          },
          // Tối ưu hóa cho SSR
          cssVar: true,
          hashed: false,
        }}
      >
        <div
          className={
            stylesLoaded ? "antd-styles-loaded" : "antd-styles-loading"
          }
        >
          {children}
        </div>
      </ConfigProvider>
    </StyleProvider>
  );
};

export default App;
